module.exports = __webpack_public_path__ + "lv.svg?35ddb2f334c25ef94cafb8373be1bcae";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/4x3/lv.svg
// module id = 1223
// module chunks = 0